import WorkbookControlVM from './WorkbookControlVM'

export default class ProcessVM extends WorkbookControlVM {
    constructor(data?: any) {
        super(data);
    }
}